/*
  Faucet page for FullStack.cash
*/

import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Container, Row, Col, Alert } from 'react-bootstrap'

function Faucet () {
  return (
    <>
      <Helmet>
        <title>Testnet Faucet - FullStack.cash</title>
      </Helmet>

      <Container className='py-5'>
        <Row>
          <Col md={{ span: 10, offset: 1 }}>
            <Alert variant='info'>
              <h2>This Faucet is no longer available.</h2>
              <h3 className='lead'>
                A new faucet can be found at{' '}
                <a href='https://tbch.googol.cash/' target='_blank' rel='noreferrer'>
                  https://tbch.googol.cash/
                </a>
              </h3>
            </Alert>
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default Faucet
